<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>代采报表汇总: {{ form.supply_name }}(数量/金额)</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
      >
        刷新
      </el-button>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-select
                  v-model="form.pgid"
                  filterable="filterable"
                  placeholder="选择代采组"
                >
                  <el-option
                    v-for="item in optionsData.pg_list"
                    :key="item.pgid"
                    :label="item.pgname"
                    :value="item.pgid"
                  >
                  </el-option>
                </el-select>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.woid"
                    placeholder="代采单"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_kh"
                    placeholder="款号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.order_owner"
                    filterable="filterable"
                    placeholder="订单负责人"
                  >
                    <el-option value="" label="">全部</el-option>
                    <el-option
                      v-for="item in optionsData.owner_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="filter_table_field"
                    placeholder="报表状态"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option value="1" label="有欠货"></el-option>
                    <el-option value="2" label="无欠货"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_dispense"
                    placeholder="含小店分发"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="请选择商家城市"
                  >
                    <el-option
                      v-for="item in optionsData.options_supply_city"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="开单时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.source"
                    placeholder="请选择开单来源"
                    multiple
                  >
                    <el-option
                      v-for="item in sources"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="outputPart">
                    导出查询数据
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="outputAll">
                    导出所有数据
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <el-table
          v-if="resData"
          v-loading="tableLoading"
          :data="resData.wcg_order_ofsupply"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" prop="supply_id" label="汇总（全部）">
            <el-table-column
              v-if="!form.order_owner"
              align="center"
              prop="supply_id"
              label="商家ID"
            ></el-table-column>
            <el-table-column
              v-if="!form.order_owner"
              align="center"
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="all_num"
              label="实际开单"
            ></el-table-column>
            <el-table-column
              prop="owe_num"
              label="代采欠货"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="已入库"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="inStock(scope.row, 1)"
                >
                  {{ scope.row.num }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="rj_wait_receive_num"
              label="退换货待接收"
              show-overflow-tooltip
              align="center"
            ></el-table-column>

            <el-table-column
              prop="rj_owe_num"
              label="退换欠货"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rj_wait_stockin_num"
              label="退换货待入库"
              show-overflow-tooltip
              align="center"
            ></el-table-column>

            <el-table-column
              prop="unded_num"
              label="待抵扣"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="use_ded_num"
              label="已抵扣"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refund_num"
              label="已退款"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <!--<el-table-column prop="hexiao_num" label="已核销" show-overflow-tooltip align="center"></el-table-column>-->
            <!--<el-table-column prop="bad_num" label="转坏账" show-overflow-tooltip align="center"></el-table-column>-->
            <el-table-column
              prop="baddebt_num"
              label="呆账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="broken_num"
              label="代采欠货坏账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="broken_num_rj"
              label="退换欠货坏账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            v-loading="tableLoading"
            :data="
              resData.list.filter((row) => {
                if (filter_table_field) {
                  if (filter_table_field == 1) {
                    return (
                      _hasOweNum(row, 'owe_num') ||
                      _hasOweNum(row, 'rj_owe_num')
                    );
                  }
                  if (filter_table_field == 2) {
                    return (
                      !_hasOweNum(row, 'owe_num') &&
                      !_hasOweNum(row, 'rj_owe_num')
                    );
                  }
                }
                return true;
              })
            "
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            :cell-class-name="addBackground"
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" label="代采订单">
              <template #default="scope">
                <p>{{ scope.row.woid }}</p>
                <p style="color: #2d59ec; font-size: 14px; line-height: 0">
                  {{ scope.row.is_dispense_label }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="owner_admin_name"
              label="订单负责人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="all_num"
              label="实际开单"
            ></el-table-column>
            <el-table-column
              prop="owe_num"
              label="代采欠货"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="已入库"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rj_wait_receive_num"
              label="退换货待接收"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rj_owe_num"
              label="退换欠货"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rj_wait_stockin_num"
              label="退换货待入库"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="unded_num"
              label="待抵扣"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="use_ded_num"
              label="已抵扣"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refund_num"
              label="已退款"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <!--<el-table-column prop="hexiao_num" label="已核销" show-overflow-tooltip align="center"></el-table-column>-->
            <!--<el-table-column prop="bad_num" label="转坏账" show-overflow-tooltip align="center"></el-table-column>-->
            <el-table-column
              prop="baddebt_num"
              label="呆账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="broken_num"
              label="代采欠货坏账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="broken_num_rj"
              label="退换欠货坏账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                >
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { getOptionsForGetDataOfWcg } from "@/openapi/erp/wcgOrder.js";

const initResData = {
  list: [],
};
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchOptions();
    });
  },
  data() {
    return {
      resData: initResData,
      optionsData: {
        pg_list: [],
        owner_option: [],
        options_supply_city: [],
      },
      supply: {
        list: [],
      },
      form: {
        status: "",
        create_time: [],
        supply_name: "",
        is_dispense: "",
        source: [1, 2, 3, 4],
      },
      filterable: true,
      loading: false,
      tableLoading: false,
      url: "/erp/WcgOrder/GetDataOfWcg",
      status: -1,
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      sources: [
        {
          key: 1,
          label: "一手",
        },
        {
          key: 2,
          label: "爆版",
        },
        {
          key: 3,
          label: "商陆花",
        },
        {
          key: 4,
          label: "聚水潭",
        },
      ],

      filter_table_field: "", // 用于筛选报表状态 {1:有欠货, 2:无欠货}
      citys: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;
      return end;
    },
    handleSelect() {},
    pickerChange() {
      this.isAll = false;
    },
    switchChange(val) {
      if (val) {
        delete this.form.create_time;
      }
    },
    tableRowClassName({ row }) {
      let sum_price = 0;
      [
        row.owe_price,
        row.price,
        row.rj_wait_receive_price,
        row.rj_owe_price,
        row.rj_wait_stockin_price,
        row.unded_price,
        row.use_ded_price,
        row.refund_price,
        row.baddebt_price,
        row.broken_price,
        row.broken_price_rj,
      ].forEach((v) => {
        sum_price += Number(v) * 100;
      });
      const all_price = row.all_price * 100;
      if (all_price !== sum_price) {
        let sum_num = 0;
        [
          row.owe_num,
          row.num,
          row.rj_wait_receive_num,
          row.rj_owe_num,
          row.rj_wait_stockin_num,
          row.unded_num,
          row.use_ded_num,
          row.refund_num,
          row.baddebt_num,
          row.broken_num,
          row.broken_num_rj,
        ].forEach((v) => {
          sum_num += Number(v);
        });
        if (sum_num == row.all_num) {
          return "notice-row";
        }
        return "warning-row";
      }
      return "";
    },
    outputAll() {
      this.form.is_excel = 1;
      this.$http
        .post("/erp/WcgOrder/getAllPurchaseWcg", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.form.is_excel = 0;
            this.$message.error(res.data.msg);
          } else {
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    outputPart() {
      this.form.is_excel = 1;
      // if (typeof(this.filteredForm.pgid) == "undefined") {
      //     this.$message.error('请选择代采组！');
      //     this.form.is_excel = 0;
      //     return
      // }

      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.form.is_excel = 0;
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (this.$route.query.supply_name) {
        this.form.supply_name = this.$route.query.supply_name;
      }
      if (this.$route.query.pgid) {
        this.form.pgid = parseInt(this.$route.query.pgid);
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.resData = initResData;
          this.$message.error(res.data.msg);
        } else {
          if (JSON.stringify(res.data.data.list) !== "[]") {
            res = this.resFormat(res);
          }
          this.resData = res.data.data;
        }
      });
    },
    fetchOptions() {
      getOptionsForGetDataOfWcg()
        .then((res) => {
          if (Object.keys(res).length > 0) {
            this.optionsData = res;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},

    handleClick(row) {
      localStorage.setItem("wcg_order_ofsupply", JSON.stringify(row)); // 保持单个订单汇总数据到本地
      let aaa;
      if (
        typeof this.form.goods_no === "undefined" &&
        typeof this.form.goods_kh !== "undefined"
      ) {
        // 有款号
        aaa = encodeURIComponent(this.form.goods_kh);
        this.$router.push(`/home/purchasing/reportdetail3/${row.woid}/${aaa}`);
      } else if (
        typeof this.form.goods_no !== "undefined" &&
        typeof this.form.goods_kh === "undefined"
      ) {
        // 有货号
        this.$router.push(
          `/home/purchasing/reportdetail2/${row.woid}/${this.form.goods_no}`
        );
      } else if (
        typeof this.form.goods_no !== "undefined" &&
        typeof this.form.goods_kh !== "undefined"
      ) {
        // 有货号和款号
        aaa = encodeURIComponent(this.form.goods_kh);
        this.$router.push(
          `/home/purchasing/reportdetail4/${row.woid}/${this.form.goods_no}/${aaa}`
        );
      } else {
        this.$router.push(`/home/purchasing/reportdetail/${row.woid}`);
      }
    },
    inStock(row, type) {
      this.$router.push(
        `/home/purchasing/stockin/${row.supply_id}/${row.pgid}/${type}`
      );
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      if (typeof this.filteredForm.woid !== "undefined") {
        if (isNaN(parseInt(this.filteredForm.woid))) {
          this.$message.error("代采单格式不正确！");
        }
        this.filteredForm.woid = this.trim(this.filteredForm.woid, "g");
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.resData = initResData;
          this.$message.error(res.data.msg);
        } else if (JSON.stringify(res.data.data.list) !== "[]") {
          res = this.resFormat(res);
          this.resData = res.data.data;
          this.supplyData = res.data.data.wcg_order_ofsupply;
          localStorage.setItem("supply_id", this.supplyData[0].supply_id);
          localStorage.setItem("supply_name", this.supplyData[0].supply_name);

          (this.status = this.filteredForm.status), (this.curPage = 1);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    addBackground({ row, columnIndex }) {
      // “代采欠货”或“退换货欠货”件数不为0时，则橙色高亮；
      if ([6, 9].includes(columnIndex)) {
        const has_owe_num = this._hasOweNum(
          row,
          { 6: "owe_num", 9: "rj_owe_num" }[columnIndex]
        );
        if (has_owe_num) {
          return "warning-cell";
        }
      }
    },
    _hasOweNum(row, field) {
      const split = row[field].split(" / ")[0];
      if (split > 0) {
        return true;
      }
      return false;
    },
    getPgSupply(value) {
      this.loading = true;
      this.form.pgid = value;
      this.$http
        .post("/erp/WcgOrder/getPgSupply", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.supply = res.data.data;
            this.$http.post(this.url, this.filteredForm).then((res) => {
              setTimeout(() => {
                this.loading = false;
              }, 200);
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                // if (JSON.stringify(res.data.data.list) !== '[]') {
                const res = this.resFormat(res);
                this.resData = res.data.data;
                // }
                // this.resData = res.data.data;
              }
            });
          }
        });
    },
    resFormat(res) {
      const func = (item) => {
        item.all_num = `${item.all_num} / ${item.all_price}`;
        item.bad_num = `${item.bad_num} / ${item.bad_price}`;
        item.num = `${item.num} / ${item.price}`;
        item.refund_num = `${item.refund_num} / ${item.refund_price}`;
        item.owe_num = `${item.owe_num} / ${item.owe_price}`;
        item.hexiao_num = `${item.hexiao_num} / ${item.hexiao_price}`;
        item.baddebt_num = `${item.baddebt_num} / ${item.baddebt_price}`;
        item.rj_owe_num = `${item.rj_owe_num} / ${item.rj_owe_price}`;
        // item.broken_num = `${item.broken_num} / ${item.broken_price}`;
        item.rj_wait_receive_num = `${item.rj_wait_receive_num} / ${item.rj_wait_receive_price}`;
        item.rj_wait_stockin_num = `${item.rj_wait_stockin_num} / ${item.rj_wait_stockin_price}`;
        item.unded_num = `${item.unded_num} / ${item.unded_price}`;
        item.use_ded_num = `${item.use_ded_num} / ${item.use_ded_price}`;
        item.broken_num = `${item.broken_num} / ${item.broken_price}`;
        item.broken_num_rj = `${item.broken_num_rj} / ${item.broken_price_rj}`;
      };
      res.data.data.list.map(func);
      res.data.data.wcg_order_ofsupply.map(func);
      return res;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseReport.vue